import fetch from 'unfetch';
/**
 *
 * @param {*} toBlock uuid of person to block
 * @returns
 */
const unBlockUser = async (toBlock) => {
	const url = `https://beta.thewavesocial.com/api/safety/unblock`;
	const res = await fetch(url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			authorization: localStorage.getItem('auth'),
		},
		body: JSON.stringify({
			toBlock: toBlock,
		}),
	});

	if (res.ok) {
		let responseData = await res.json();

		return 0;
	} else {
		let h = await res.json();

		return 1;
	}
};

export default unBlockUser;
